import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import type { AeCampaignFunnelSummary } from '@/types/assessmentEngine';

interface CampaignFunnelSummaryProps {
  summary: AeCampaignFunnelSummary;
}

/** Distribution funnel counts (invited → complete). */
export const CampaignFunnelSummary: React.FC<CampaignFunnelSummaryProps> = ({ summary }) => {
  const { t } = useLanguage();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 text-center text-sm">
        {(
          [
            ['invited', summary.invited],
            ['sent', summary.sent],
            ['clicked', summary.clicked],
            ['started', summary.started],
            ['complete', summary.complete],
          ] as const
        ).map(([key, count]) => (
          <div key={key} className="bg-[var(--color-hover-bg)] rounded p-2">
            <p className="text-lg font-semibold text-[var(--color-surface-text)]">{count}</p>
            <p className="text-xs text-[var(--color-secondary-text)]">
              {t(`assessmentEngine.hub.funnel${key.charAt(0).toUpperCase()}${key.slice(1)}`)}
            </p>
          </div>
        ))}
      </div>
  );
};
